/**
 * Типы для маршрутов
 * в этом файле описываются дто маршрутов, которые приходят в сыром виде с сервера
 * сейчас пока что нет различий между дто и доменом, но в будущем будет
 * из-за неконтролируемого проектирования таблиц в базе данных
 */
import { zRouteSchemaDom } from "./route.domain";
export const zRouteSchemaDto = zRouteSchemaDom;
